import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import AppRoutes from "./routes/AppRoutes";
import "antd/dist/reset.css";
import "./styles/components.scss";
import store from "./store/store";
import { Provider } from "react-redux";
import TokenExpiration from "./auth/Tasks/tokenExpiration";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <TokenExpiration />
      <AppRoutes />
    </Provider>
  </StrictMode>
);
